import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IMerchantPartnerDeleteRequest {
  merchantId: number;
  partnerOrder: number;
}

async function merchantPartnerDelete(
  data: IMerchantPartnerDeleteRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/MerchantPartner/DeleteMerchantPartner", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any)?.error || "Silme işlemi başarısız!";
  }
}

export function useMerchantPartnerDelete() {
  return useMutation<any, Error, IMerchantPartnerDeleteRequest>((variables) =>
    merchantPartnerDelete(variables)
  );
}